import { ds } from '@/components/lib/design.system';

export const GRADIENT_COLORS = [
    ds.colorValue.icon.brand,
    ds.colorValue.background.pickType.surge.strong,
    ds.colorValue.background.accent.yellow.strong,
];

export type NormalizedGradientStop = {
    color: string;
    offset: number;
};

/**
 * Normalizes gradient positions and calculates boundaries
 * @param colors - Array of color strings (hex, rgb, etc.)
 * @param positions - Array of position values (can be outside 0-1 range)
 * @param width - Width in pixels to calculate gradient boundaries
 * @returns Normalized stops and gradient boundaries (startX, endX)
 */
export const normalizeGradient = (
    colors: string[],
    positions: number[],
    width: number
): { stops: NormalizedGradientStop[]; startX: number; endX: number } => {
    let minPos = positions[0];
    let maxPos = positions[positions.length - 1];

    if (maxPos === minPos) {
        maxPos = minPos + 1; // avoid division by zero
    }

    const span = maxPos - minPos;

    // Normalize stop positions to 0-1 range
    const stops = colors.map((color, i) => ({
        color,
        offset: (positions[i] - minPos) / span,
    }));

    // Calculate gradient boundaries in pixels
    // Positions are fractional values (0-1 range)
    const startX = minPos * width;
    const endX = maxPos * width;

    return { stops, startX, endX };
};
